import {PROTECTED_SELLER_MGM} from 'constants/pageRoutes';

export const kpiData = [
  {name: 'SellerResponsivenessScore', type: 1, translationKey: 'component.seller.kpis.seller', walkme: 'sdashboard-image-vous'},
  {name: 'DebtorsResponsivenessScore', type: 1, translationKey: 'component.seller.kpis.debtors', walkme: 'sdashboard-image-vosclients'},
  {name: 'SponsorshipTotalVolume', type: 1, translationKey: 'component.seller.sponsorship.volume', walkme: 'sdashboard-image-volumetotal'},
  {name: 'SponsorshipCredits', type: 2, translationKey: 'component.seller.sponsorship.credits', walkme: 'sdashboard-number-creditsparrainage', btnTranslationKey: 'seller.kpis.btn.mgm', btnURL: PROTECTED_SELLER_MGM}
];
